import { useSelector } from "react-redux";
import { selectTheme } from "../../store/selectors/auth.selector";
import { ReactNode, MouseEvent } from "react";
import TruncatedText from "./TruncatedText";
import PageBreadcrumbs from "./PageBreadcrumbs";
import { getStageColor } from "../../utils/formattingFns";
import { Skeleton } from "@mui/material";

export default function SinglePageHeader({ 
    status, 
    isLoading, 
    id, 
    label, 
    children, 
    metadata, 
    pages, 
    itemMetadata 
}: {
    status?: string | null,
    isLoading?: boolean,
    id?: string,
    label: string,
    children?: ReactNode,
    metadata?: ReactNode,
    pages: { label: string, action?: (e: MouseEvent<HTMLButtonElement>) => void }[],
    itemMetadata?: {
        label: string,
        value: string | string[],
        adornment?: ReactNode,
    }[],
}) {
    const theme = useSelector(selectTheme);

    return (
    <div className="w-full flex flex-col justify-start items-start gap-4 mb-4">
        <div className="w-full flex justify-between items-start gap-10">
            <div className='flex flex-col justify-start items-start gap-6 grow'>
                {isLoading ? (
                <>
                    <Skeleton variant='text' width='100%' sx={{fontSize: '14px'}}/>
                    <Skeleton variant='text' width='100%' sx={{fontSize: '2rem'}}/>
                </>
                ) : (            
                <>
                    <div className={`flex justify-center items-center gap-1 ${theme === 'dark' && 'whiten'}`}>
                        <PageBreadcrumbs pages={pages}/>
                    </div>
                    <div className="flex flex-col gap-3 justify-start items-start">
                        <div className="flex justify-start items-start gap-4">
                            <TruncatedText text={label} alignment="left">
                                <p className="font-semibold text-[2rem] text-default max-w-[800px] truncate">
                                    {label}
                                </p>
                            </TruncatedText>
                            {status && (
                                <div style={{backgroundColor: `${getStageColor(status).background}`}} className="rounded-full py-2 px-4 mt-1">
                                    <p style={{color: `${getStageColor(status).label}`}} className="font-semibold">{status}</p>
                                </div>
                            )}
                        </div>
                        {metadata}
                    </div>
                    
                </>
                )}
            </div>
            <div id={id} className='flex gap-3'>
                {children}
            </div>
        </div>
        {itemMetadata && itemMetadata.length > 0 && (
            <div className="flex justify-start items-center gap-6">
                {itemMetadata.map((meta,i) => (
                    <div key={i} className="flex justify-start items-center gap-2">
                        {meta.adornment && <div className="w-[16px] text-disable">{meta.adornment}</div>}
                        <p className="text-disable font-semibold">{meta.label}:</p>
                        {typeof meta.value === 'string' ? (
                            <p className="text-primary font-semibold">{meta.value}</p>
                        ) : (
                            <div className='flex justify-start items-center gap-1'>
                                {meta.value.map(value => (
                                    <div className="py-1 px-2 rounded-lg bg-secondary text-primary font-semibold text-[10px]">{value}</div>
                                ))}
                            </div>
                        )}
                        
                    </div>
                ))}
            </div>
        )}
    </div>
    )
}